// This stores Melville API responses to avoid re-loading libraries each time a different menu opens.
let libraries = null;

export default {
  getLibraries: () => libraries,
  setLibraries: (newLibraries) => {
    libraries = newLibraries;
  }
};
